import Rails from "@rails/ujs"
Rails.start()
global.Rails = Rails;

import "bootstrap";
window.bootstrap = require('bootstrap');